import { render } from "./MultipleChoiceMinMaxHorizontal.vue?vue&type=template&id=759dbcc7"
import script from "./MultipleChoiceMinMaxHorizontal.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceMinMaxHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__